import { render } from "./SettingSync.vue?vue&type=template&id=396d001b&scoped=true"
import script from "./SettingSync.vue?vue&type=script&lang=js"
export * from "./SettingSync.vue?vue&type=script&lang=js"

import "./SettingSync.vue?vue&type=style&index=0&id=396d001b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-396d001b"]])

export default __exports__